// extracted by mini-css-extract-plugin
module.exports = {"subSection":"SocialSharePage_subSection__M6G_9","sectionHeading":"SocialSharePage_sectionHeading__y8ZXQ","section":"SocialSharePage_section__PKkh1"};